<template>
  <div class="welcome">
    <h1>webcg-studio</h1>
    <p>
      {{ status }}
      <icon v-if="!hasError" name="spinner" class="fa-spin"></icon>
    </p>
  </div>
</template>

<script>
  import * as action from '../store/action-types'

  export default {
    name: 'welcome',
    data () {
      return {
        error: null
      }
    },
    computed: {
      hasError () {
        return !!(this.error || (this.accounts && !this.selectedAccount))
      },
      status () {
        if (this.error) return 'Failed to fetch accounts'
        if (!this.authenticated) return 'Authenticating...'
        if (!this.accounts) return 'Fetching accounts...'
        if (!this.selectedAccount) {
          const accountId = this.$route.params.accountId
          return accountId ? `Account '${accountId}' does not exist` : 'Account does not exist'
        }
        if (!this.connected) return 'Connecting...'
        return 'Loading...'
      },
      authenticated () {
        return this.$keycloak.authenticated
      },
      accounts () {
        return this.$store.getters.accounts
      },
      selectedAccount () {
        return this.$store.getters.selectedAccount
      },
      connected () {
        return this.$store.getters.connected
      }
    },
    created () {
      this.checkAndFetchAccounts()
      this.transitionToWorkspace()
    },
    methods: {
      checkAndFetchAccounts () {
        if (this.authenticated && !this.accounts) {
          this.error = null
          this.$store.dispatch(action.FETCH_ACCOUNTS, {
            keycloak: this.$keycloak,
            env: this.$env,
            accountId: this.$route.params.accountId
          }).catch(error => {
            this.error = error
          })
        }
      },
      transitionToWorkspace () {
        if (this.connected && this.authenticated && this.selectedAccount) {
          if (this.$route.params.accountId) {
            this.$router.push('/' + this.$route.params.accountId + '/workspace')
          } else {
            this.$router.push('/' + this.selectedAccount.accountId + '/workspace')
          }
        }
      }
    },
    watch: {
      authenticated: function (val) {
        if (val) {
          this.checkAndFetchAccounts()
        }
        this.transitionToWorkspace()
      },
      selectedAccount: function () {
        this.transitionToWorkspace()
      },
      connected: function () {
        this.transitionToWorkspace()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .welcome {
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
    position: fixed;
    font-size: 20px;
    font-weight: normal;
    text-align: center;
    color: #555;

    h1 {
      font-size: 40px;
      font-weight: bold;
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/welcome.vue